import React, { useState } from 'react'
import FadeInHOC from '../FadeInHOC'
import clsx from 'clsx'
import { Magnifier } from 'react-image-magnifiers'
import Zoom from '../icons/Zoom'
import Close from '../icons/Close'
import styles from './PhotoModal.module.sass'
import { PhotoModalConfig } from '../configuration'

export default function PhotoModal({ img, zoomedImg }) {
    const [dialog, setDialogOpen] = useState({
        open: false,
        animate: false
    })
    const [isImageZoomed, setImageZoomed] = useState(false)
    const handleToggleDialog = () => {
        setDialogOpen({ animate: true, open: !dialog.open })
    }
    return (
        <>
            <div
                className={clsx(
                    styles.paper,
                    !dialog.open && 'dialog-fadeOut',
                    dialog.open && 'dialog-fadeIn',
                    !dialog.animate && 'hideDialog'
                )}
            >
                <div className={styles.overlay} onClick={() => setDialogOpen({ animate: true, open: false })} /> 
                <span className={styles.wrapper} >
                    <button onClick={handleToggleDialog} className={styles.closeBtn} alt='close button'>
                        <Close />
                    </button>
                    <Magnifier
                        className={styles.magnifier}
                        imageSrc={zoomedImg} // Show rectangular image in modal
                        largeImageSrc={zoomedImg} // Zoom on the rectangular image
                        touchActivation='doubleTap'
                        mouseActivation='doubleClick'
                        onZoomStart={() => setImageZoomed(true)}
                        onZoomEnd={() => setImageZoomed(false)}
                    />
                    <p className={clsx(styles.accesibility, isImageZoomed && 'helper-text-fadeOut')}>{PhotoModalConfig.zoomInText}</p>
                    <p className={clsx(styles.accesibility, !isImageZoomed && 'helper-text-fadeOut')}>{PhotoModalConfig.dragToExploreText}</p>
                </span>
            </div>
            <FadeInHOC rootClass={styles.root} >
                <div className={styles.zoomImg} >
                    <img onClick={handleToggleDialog} className={styles.image} src={img} alt='Formato Brick' />
                    <button onClick={handleToggleDialog} className={styles.zoomBtn} alt='zoom in button'>
                        <Zoom className={styles.zoomBtnIcon} />
                    </button>
                </div>
            </FadeInHOC>
        </>
    )
}
